import { config } from '../../config';

/**
 * Collects all devices from multiple rooms and adds device type to each device
 * @param {Array} roomsWithNonEmptyEnergySync - Array of room objects containing device arrays
 * @returns {Array} Array of all devices from all rooms with type property added
 */
export const allTypeOfDevices = (roomsWithNonEmptyEnergySync) => {
    // Guard: rooms can be undefined when no house is selected / the house fetch failed.
    const rooms = Array.isArray(roomsWithNonEmptyEnergySync) ? roomsWithNonEmptyEnergySync : [];

    const defaultRoomAllDevices = [
        ...rooms.flatMap((room) =>
            (room?.energiSync || []).map((e) => {
                return { ...e, type: config.deviceType.energiSync,roomName:room?.roomName,roomId:room?._id };
            })
        ),
        ...rooms.flatMap((room) =>
            (room?.thermoSmarts || []).map((e) => {
                return { ...e, type: config.deviceType.thermoSmarts,roomName:room?.roomName,roomId:room?._id };
            })
        ),
        ...rooms.flatMap((room) =>
            (room?.weatherSensors || []).map((e) => {
                return { ...e, type: config.deviceType.weatherSensors,roomName:room?.roomName,roomId:room?._id };
            })
        ),
        ...rooms.flatMap((room) =>
            (room?.environSyncs || []).map((e) => {
                return { ...e, type: config.deviceType.environSyncs,roomName:room?.roomName,roomId:room?._id };
            })
        ),
        ...rooms.flatMap((room) =>
            (room?.doorSensors || []).map((e) => {
                return { ...e, type: config.deviceType.doorSensors,roomName:room?.roomName,roomId:room?._id};
            })
        )
    ];

    return defaultRoomAllDevices;
};